/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  Form,
  Input,
  Row,
  Col,
  Spin,
  Card,
  Tabs,
  Button,
  DatePicker,
  message,
  Divider,
  Typography,
} from 'antd';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import { RFC_PATTERN } from 'utils/patterns';
import LadaNumero from 'components/LadaNumero';
import Direccion from 'components/Direccion';
import { DATE_FRONTEND_FORMAT, discartNullValues } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import NumericInput from 'components/NumericInput';
import { InputSearchPro } from 'components/InputSearch';
import Select from 'components/Select';
import makeMessager from 'utils/complexFormsMessages';
import BusquedaAvanzadaPredio from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { isMutable } from 'utils/estadosGlobales';
import { makeGetOnFinish, makeOnChangeTabKey } from 'utils/tabsManagement';
import Anuncios, { permissionConfig as permissionConfigAnuncio } from 'components/Catalogos/Anuncios';
import { capitalize, toUpper } from 'utils/normalizers';

import {
  getCiudadano,
  // getCiudadanos,
} from 'api/cuentaunicasir';
import {
  getClasificacionesDeComercio,
  getTiposDeEmpresas,
  getTiposDeEstablecimiento,
  getScian,
} from 'api/empresas';
import {
  baseURI,
  deleteEmpresa,
  getEmpresa,
  getEmpresas,
  patchEmpresa,
  postEmpresa,
} from 'api/empresas/empresas';
import { getPredio, getPredios } from 'api/catastro/predio';
import { getUnidadesDeRecaudacion } from 'api/configuracion/unidadesDeRecaudacion';
import { getClasesDeActividadesEmpresariales } from 'api/empresas/claseDeActividadEmpresarial';
import { getContribuyente, getContribuyenteCaja } from 'api/empresas/contribuyentes';
import useQuery from 'hooks/useQuery';
import checkToken from 'api/utils/checkToken';
import { getCiudadanoCaja } from 'api/cuentaunicasir/index';
import { getRegimenCapital } from 'api/catalogos';
import { getTiposDePersonas } from 'api/catalogos/tipoDePersona';
import BusquedaAvanzadaSCIAN from 'components/BusquedaAvanzadaSCIAN';
import { getModelPermission } from 'utils/permission';
import { DeleteOutlined, SearchOutlined } from '@ant-design/icons';

const { TextArea } = Input;
const { TabPane } = Tabs;
const { Title } = Typography;

export const permissionConfig = {
  permissionModel: 'empresa',
  catalogsModels: [
    'tipodeempresa',
    'contribuyente',
    'clasificaciondecomercio',
    'clasedeactividadempresarial',
    'unidadderecaudacion',
    'ciudadano',
    'estadosglobales',
    'predio',
    'sectorcomercial',
    'tipodeestablecimiento',
  ],
  tabsModels: [permissionConfigAnuncio],
};

const Empresas = ({ permission }) => {
  const {
    tiposDeEmpresa,
    clasificacionesDeComercio,
    estadosGlobales,
  } = useSelector((state) => state.catalogs);
  const [form] = Form.useForm();
  const [formFiscales] = Form.useForm();
  const [formInfo] = Form.useForm();
  const [formDocuments] = Form.useForm();
  const [formSearch] = Form.useForm();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState({ results: [] });
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [mutable, setMutable] = useState(true);
  const [formAddress, setFormAddress] = useState();
  const [predio, setPredio] = useState([]);
  const [visibleBusqueda, setVisibleBusqueda] = useState(false);
  const [dataExterno, setDataExterno] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [ciudadanoFound, setCiudadanoFound] = useState([]);
  const [contribuyenteFound, setContribuyenteFound] = useState([]);
  const [unidadesDeRecaudacion, setUnidadesDeRecaudacion] = useState([]);
  const [claseActividad, setClaseActividad] = useState([]);
  const [visibleBusquedaAvanzada, setVisibleBusquedaAvanzada] = useState(false);
  const [visibleBusquedaContribuyente, setVisibleBusquedaContribuyente] = useState(false);
  // const [sectorEmpresarial, setSectorEmpresarial] = useState([]);
  const [tipoDeEstablecimiento, setTipoDeEstablecimiento] = useState([]);
  const [regimenCapital, setRegimenCapital] = useState([]);
  const [tipoDePersona, setTipoDePersona] = useState([]);
  const [empresaSelected, setEmpresaSelected] = useState([]);
  const [visibleAdvanced, setvisibleAdvanced] = useState(false);
  const [actividadFound, setActividadFound] = useState([]);
  const [justView, setJustView] = useState(false);

  const addressPermission = useMemo(() => getModelPermission('direccion'), []);
  const params = useQuery(['id']);

  const basicKeys = [
    'general',
    'info',
    'complementarios',
  ];

  const formInstances = [
    form,
    formFiscales,
    formInfo,
  ];

  const complexForms = [{
    key: 'domicilio',
    formInstance: formAddress,
    permission: addressPermission,
  }];

  const fetchData = async (page = 1, q = null) => {
    setLoading(true);
    setCurrentPage(page);
    const _data = await getEmpresas({ page, ...q });
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      checkToken();
      setLoading(true);
      // eslint-disable-next-line max-len
      const [_unidadesDeRecaudacion, _actividadesEmpresariales, _regimenCapital, _establecimientos, _tiposPersonas] = await Promise.all([
        // getSectoresComerciales(),
        getUnidadesDeRecaudacion(),
        getClasesDeActividadesEmpresariales(),
        getRegimenCapital(),
        getTiposDeEstablecimiento(),
        getTiposDePersonas(),
      ]);
      await getClasificacionesDeComercio();
      await getTiposDeEmpresas();
      if (mounted) {
        setUnidadesDeRecaudacion(_unidadesDeRecaudacion);
        setTipoDeEstablecimiento(_establecimientos);
        setClaseActividad(_actividadesEmpresariales);
        // setSectorEmpresarial(_sectores);
        setRegimenCapital(_regimenCapital);
        setTipoDePersona(_tiposPersonas);
        setLoading(false);
      }
    };
    if (permission.hasAllViewPermission) {
      fetchAll();
      if (params[0] !== null) {
        setTimeout(() => {
          // eslint-disable-next-line no-use-before-define
          onClickEdit(null, params[0]);
          setSelectedRowKeys([params[0]]);
        });
      }
    }
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
    formFiscales.resetFields();
    formInfo.resetFields();
    setSelectedRowKeys([]);
    setCurrentTabKey('general');
    setPredio([]);
    setCiudadanoFound([]);
    setContribuyenteFound([]);
    setActividadFound([]);
    setMutable(true);
    setData({ results: [] });
    setJustView(false);
  };

  const handleSearchData = async () => {
    try {
      setLoading(true);
      await formSearch.validateFields();
      const searchParams = formSearch.getFieldsValue();
      const keys = Object.keys(searchParams);
      const validProps = keys.filter((prop) => searchParams[prop]);
      if (validProps?.length) {
        const _data = await getEmpresas(searchParams);
        setData(_data);
      } else {
        message.warn('Debe ingresar al menos un campo.');
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const wipe = () => {
    formSearch.resetFields();
    setData({ results: [] });
  };

  const fetchCiudadano = async (id) => {
    setLoading(true);
    if (id) {
      const _ciudadano = await getCiudadano(id);
      if (_ciudadano) {
        setCiudadanoFound([_ciudadano]);
        setTimeout(() => {
          form.setFieldsValue({
            ciudadano: _ciudadano.id,
          });
        }, 100);
      } else {
        message.info('No se encontró ciudadano');
        setCiudadanoFound([]);
      }
    }
    setLoading(false);
  };

  const contribuyenteInfo = async (_contribuyente) => {
    if (_contribuyente) {
      const _tipo_persona = tipoDePersona.find((t) => t.id === _contribuyente.tipo_de_persona);
      const _regimen_capital = regimenCapital.find((r) => r.id === _contribuyente?.regimen_capital);
      form.setFieldsValue({
        tipo_de_persona: _tipo_persona?.descripcion,
        nombre_comercial_contribuyente: _contribuyente?.nombre_comercial,
        razon_social: _contribuyente?.razon_social,
        regimen_capital_contribuyente: _regimen_capital?.descripcion || 'No aplica',
      });
    }
  };

  const fetchContribuyente = async (id) => {
    setLoading(true);
    if (id) {
      const _contribuyente = await getContribuyente(id);
      if (_contribuyente) {
        await contribuyenteInfo(_contribuyente);
        setContribuyenteFound([_contribuyente]);
        setTimeout(() => {
          form.setFieldsValue({
            contribuyente: _contribuyente?.id,
          }, 100);
        });
      } else {
        message.info('No se encontró al contribuyente');
        setContribuyenteFound([]);
      }
    }
    setLoading(false);
  };

  const fetchPredio = async (id) => {
    setLoading(true);
    if (id) {
      const _predio = await getPredio(id);
      if (_predio) {
        setPredio([_predio]);
        setTimeout(() => {
          formFiscales.setFieldsValue({
            predio: _predio?.id,
          });
        }, 100);
      } else {
        message.info('No se encontró el predio');
        setPredio([]);
      }
    }
    setLoading(false);
  };

  const fetchClaseScian = async (selected) => {
    setLoading(true);
    const _scian = await getScian(selected || selected?.id);
    if (_scian) {
      _scian.titulo_completo = `${_scian.codigo} - ${_scian.titulo}`;
      setTimeout(() => {
        setActividadFound([_scian]);
        formInfo.setFieldsValue({ giros_scian: _scian.id });
      }, 100);
    } else {
      setActividadFound([]);
    }
    setLoading(false);
  };

  const onClickEdit = async (responseData = null, id = null) => {
    setLoading(true);
    const key = selectedRowKeys[0] || id;
    const match = responseData || await getEmpresa(key);
    const idContribuyente = typeof match?.contribuyente === 'object'
      ? match?.contribuyente?.id : match?.contribuyente;
    const idCiudadano = typeof match?.ciudadano === 'object'
      ? match?.ciudadano?.id : match?.ciudadano;
    const idPredio = typeof match?.predio === 'object'
      ? match?.predio?.id : match?.predio;
    if (idPredio) {
      const _predio = await getPredio(idPredio);
      setPredio([_predio]);
    }
    setTimeout(() => {
      if (match) {
        setEmpresaSelected(match);
        setMutable(isMutable(match.estados_globales));
        // form.resetFields();
        setTimeout(async () => {
          await fetchContribuyente(idContribuyente);
          form.setFieldsValue(match);
          await fetchCiudadano(idCiudadano);
          formFiscales.setFieldsValue(match);
          if (match?.giros_scian) {
            await fetchClaseScian(match.giros_scian);
          }
          formInfo.setFieldsValue(match);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formFiscales.validateFields();
      await formInfo.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formFiscales.getFieldsValue(),
        ...formInfo.getFieldsValue(),
        ...formDocuments.getFieldsValue(),
      };
      delete values.documentos_de_tramite;
      if (typeof values?.contribuyente === 'object') {
        values.contribuyente = values.contribuyente.id;
      }
      if (typeof values?.ciudadano === 'object') {
        values.ciudadano = values.ciudadano.id;
      }
      if (typeof values?.predio === 'object') {
        values.predio = values.predio.id;
      }
      const [key] = selectedRowKeys;
      const _data = await (key
        ? patchEmpresa(key, values) : postEmpresa(values));
      if (_data) {
        if (_continue) {
          if (!key) {
            setSelectedRowKeys([_data.id]);
          }
          await onClickEdit(_data, _data.id);
        } else {
          onCancel();
        }
        setLoading(false);
        return _data;
      }
      setLoading(false);
      return true;
    } catch (err) {
      onError(err, setLoading, formInstances, setCurrentTabKey);
      return false;
    }
  };

  const deleteItem = async () => {
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteEmpresa(key);
      if (deleted) {
        setVisibleAlert(false);
        onCancel();
      }
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.resetFields();
    formFiscales.resetFields();
    setTimeout(() => {
      const values = discartNullValues(record);
      form.setFieldsValue(values);
      formFiscales.setFieldsValue(values);
      formInfo.setFieldsValue(values);
      formDocuments.setFieldsValue(values);
    });
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const columns = [
    {
      titleText: 'Clave',
      key: 'clave',
      dataIndex: 'clave',
      width: 150,
    },
    {
      titleText: 'Nombre Comercial',
      key: 'nombre_comercial',
      dataIndex: 'nombre_comercial',
      width: 300,
    },
    {
      titleText: 'RFC',
      key: 'contribuyente__rfc',
      dataIndex: 'contribuyente__rfc',
      render: (val, record) => record?.contribuyente?.rfc,
      filterName: 'contribuyente__rfc',
      width: 300,
    },
    {
      titleText: 'Establecimiento',
      key: 'tipo_de_establecimiento',
      dataIndex: 'tipo_de_establecimiento',
      render: (text) => clasificacionesDeComercio.find((item) => item.id === text)?.descripcion || 'N/A',
      width: 300,
    },
  ];

  const requiredRule = { required: true };

  const rules = {
    required: [requiredRule],
    RFC: [
      {
        validator: async (rule, value) => {
          const { es_persona_fisica } = formFiscales.getFieldValue();
          if (value) {
            if (!RFC_PATTERN.test(value)
              || (!es_persona_fisica && value.length === 13)
              || (es_persona_fisica && value.length === 12)) {
              throw new Error('Ingrese un RFC válido');
            }
          }
        },
      },
    ],
    sitio_web: [
      {
        type: 'url',
        message: 'Ingrese una URL válida',
      },
    ],
    email: [
      { type: 'email' },
    ],
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const resetAndValidate = () => {
    setCiudadanoFound([]);
    formInfo.resetFields(['q']);
    formInfo.validateFields(['q']);
  };

  const resetAndValidateContribuyente = () => {
    form.setFieldsValue({
      tipo_de_persona: '',
      razon_social: '',
      nombre_comercial_contribuyente: '',
      regimen_capital_contribuyente: '',
    });
    setContribuyenteFound([]);
    form.resetFields(['q_contribuyente']);
    form.validateFields(['q_contribuyente']);
  };

  const searchCiudadano = async () => {
    try {
      setLoading(true);
      await form.validateFields(['q']);
      const { q } = form.getFieldsValue(['q']);
      if (q) {
        const _ciudadanos = await getCiudadanoCaja({ q });
        if (_ciudadanos.results.length) {
          const [selected] = _ciudadanos.results;
          form.setFieldsValue({
            ciudadano: selected.id,
          });
          setCiudadanoFound([selected]);
        } else if (!_ciudadanos.results.length) {
          message.info('No se encontró ciudadano');
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const searchContribuyente = async () => {
    try {
      setLoading(true);
      await form.validateFields(['q']);
      const { q_contribuyente: q } = form.getFieldsValue();
      if (q) {
        const contribuyentes = await getContribuyenteCaja({ rfc: q });
        if (contribuyentes.results.length) {
          const [selected] = contribuyentes.results;
          form.setFieldsValue({
            contribuyente: selected.id,
            razon_social: selected.razon_social,
          });
          await contribuyenteInfo(contribuyentes.results[0]);
          setContribuyenteFound([selected]);
        } else if (!contribuyentes.results.length) {
          message.info('No se encontró al Contribuyente.');
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const showMsg = makeMessager(setCurrentTabKey, fetchData);

  const handleSearch = async () => {
    setLoading(true);
    await formFiscales.validateFields(['q']);
    const { q } = formFiscales.getFieldsValue(['q']);
    if (q) {
      const _predios = await getPredios({ q });
      if (_predios?.results.length === 1) {
        const [selected] = _predios?.results;
        formFiscales.setFieldsValue({
          predio: selected.id,
          participe_principal: selected.participe_principal,
        });
        setPredio(selected);
      } else if (_predios.results.length > 1) {
        setDataExterno(_predios);
        setVisibleBusqueda(true);
      } else {
        message.info('No se encontró Predio');
      }
    }
    setLoading(false);
  };

  let timeoutBusqueda;
  const onSearch = () => {
    clearTimeout(timeoutBusqueda);
    timeoutBusqueda = setTimeout(handleSearch, 2000);
  };

  const onSearchSCIAN = async () => {
    try {
      setLoading(true);
      await formInfo.validateFields(['q']);
      const { q } = formInfo.getFieldsValue(['q']);
      if (!q) {
        message.info('Ingrese algún dato para buscar la actividad SCIAN');
        return;
      }
      const _scian = await getScian({ q });
      if (_scian.results.length) {
        const [selected] = _scian.results;
        formInfo.setFieldsValue({
          giros_scian: selected.id,
        });
        setClaseActividad([selected]);
      } else if (!_scian.results.length) {
        message.info('No se encontró actividad SCIAN');
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys, complexForms, currentTabKey, setCurrentTabKey, showMsg,
  );

  const resetAndValidateActividad = () => {
    form.resetFields();
    setActividadFound([]);
    form.validateFields();
  };

  const getOnFinish = makeGetOnFinish(basicKeys, complexForms, currentTabKey, onFinish);

  return (
    <Row align="center" justify="center" className="container">
      <Col xs={24} sm={24} md={24}>
        <Spin tip="Cargando..." spinning={loading}>
          {!visible ? (
            <>
              <Form
                layout="vertical"
                form={formSearch}
                scrollToFirstError
                onFinish={() => handleSearchData()}
              >
                <Row gutter={10}>
                  <Col md={8} sm={24} xs={24}>
                    <Form.Item
                      label="Clave"
                      name="clave"
                      normalize={capitalize}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col md={8} sm={24} xs={24}>
                    <Form.Item
                      label="Nombre comercial"
                      name="nombre_comercial"
                      normalize={capitalize}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col md={8} sm={24} xs={24}>
                    <Form.Item
                      label="Página web"
                      name="pagina_web"
                      normalize={capitalize}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col md={8} sm={24} xs={24}>
                    <Form.Item
                      label="RFC"
                      rules={rules.RFC}
                      name="RFC"
                      normalize={(val) => val.toUpperCase()}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col md={8} sm={24} xs={24}>
                    <Form.Item
                      label="Tipo de establecimiento"
                      name="tipo_de_establecimiento"
                      normalize={capitalize}
                    >
                      <Select
                        dataSource={tipoDeEstablecimiento}
                        labelProp="nombre"

                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Divider style={{ marginTop: 0 }}>Por Dirección</Divider>
                  </Col>
                  <Col md={8} sm={24} xs={24}>
                    <NumericInput
                      label="Código postal"
                      name="domicilio_fiscal__codigo_postal"
                      normalize={capitalize}
                    />
                  </Col>
                  <Col md={6} sm={24} xs={24}>
                    <Form.Item
                      label="Calle principal"
                      name="domicilio_fiscal__calle_principal"
                      normalize={capitalize}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col md={8} sm={24} xs={24}>
                    <Form.Item
                      label="Número exterior"
                      name="domicilio_fiscal__numero_exterior"
                      normalize={capitalize}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Button
                      onClick={handleSearchData}
                      block
                      style={{ marginTop: 21 }}
                    >
                      <SearchOutlined />
                      <Typography.Text>
                        Buscar
                      </Typography.Text>
                    </Button>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Button
                      onClick={wipe}
                      block
                      style={{ marginTop: 21 }}
                    >
                      <DeleteOutlined />
                      <Typography.Text>
                        Limpiar Busqueda
                      </Typography.Text>
                    </Button>
                  </Col>
                </Row>
              </Form>
              <Table
                cols={columns}
                data={data?.results}
                rowSelection={rowSelection}
                handleOnRowClick={handleOnRowClick}
                controls={{
                  onClickAdd,
                  onClickEdit: () => onClickEdit(null),
                  onClickDelete,
                  onClickExpand: () => {
                    setJustView(true);
                    onClickEdit(null);
                  },
                }}
                rowKey="id"
                permission={permission}
                pagination={false}
                paginationCallback={fetchData}
                count={data.count}
                currentPage={currentPage}
                allowExpand
              />
            </>
          ) : (
            <Card
              className="form-container no-padding"
              title={`${selectedRowKeys.length ? `Editando: ${empresaSelected?.clave} - ${empresaSelected?.nombre_comercial || ''}` : 'Agregar'} Empresa`}
              extra={(
                <FormSubmitControls
                  onFinish={justView ? null : getOnFinish()}
                  onCancel={onCancel}
                  mutable={mutable}
                  onCancelText="Cancelar"
                  permission={permission}
                  allowSaveAndContinue={!justView}
                />
              )}
              bordered={false}
            >
              <Tabs
                onChange={mutable ? onChangeTabKey : setCurrentTabKey}
                activeKey={currentTabKey}
                type="card"
              >
                <TabPane tab="Datos Generales" key="general" forceRender>
                  <Form
                    layout="vertical"
                    name="general"
                    form={form}
                    onFinish={() => onFinish()}
                    scrollToFirstError
                    initialValues={{ estados_globales: 1 }}
                  >
                    <Row gutter={10}>
                      {!!selectedRowKeys.length && (
                        <Col xs={24} sm={24} md={4}>
                          <Form.Item
                            name="clave"
                            label="Clave"
                            hasFeedback
                          >
                            <Input disabled allowClear />
                          </Form.Item>
                        </Col>
                      )}
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          name="nombre_comercial"
                          label="Nombre comercial"
                          required
                          maxLength={250}
                          hasFeedback
                          normalize={toUpper}
                        >
                          <Input allowClear />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} />
                      <InputSearchPro
                        label="RFC de Contribuyente"
                        name="q_contribuyente"
                        required
                        onClickAdvanced={() => setVisibleBusquedaContribuyente(true)}
                        breakPoints={{
                          xs: 24,
                          sm: 24,
                          md: 8,
                        }}
                        inputProps={{
                          onPressEnter: () => searchContribuyente(),
                          onChange: ({ target: { value } }) => {
                            if (!value) {
                              resetAndValidateContribuyente();
                            }
                          },
                        }}
                        resultProps={{
                          label: 'RFC',
                          name: 'contribuyente',
                          dataSource: contribuyenteFound,
                          labelProp: 'rfc',
                          onClearConfirm: resetAndValidateContribuyente,
                          contentConfirm: 'Si se realiza, se quitará cualquier relación con la empresa.',
                          breakPoints: {
                            xs: 24,
                            sm: 24,
                            md: 8,
                          },
                        }}
                      />
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipo_de_persona"
                          label="Tipo de Persona"
                        >
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="razon_social"
                          label="Denominación o Razón Social"
                          normalize={toUpper}
                        >
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="regimen_capital_contribuyente"
                          label="Régimen Societario o de Capital"
                        >
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="nombre_comercial_contribuyente"
                          label="Nombre comercial"
                        >
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={4} />
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="unidad_recaudadora"
                          label="Unidad Recaudadora"
                        >
                          <Select
                            disabled={justView}
                            dataSource={unidadesDeRecaudacion}
                            allowClear
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} />
                      <InputSearchPro
                        label="Ciudadano"
                        name="q"
                        disabled={justView}
                        onClickAdvanced={() => setVisibleBusquedaAvanzada(true)}
                        breakPoints={{
                          xs: 24,
                          sm: 24,
                          md: 8,
                        }}
                        inputProps={{
                          onPressEnter: () => searchCiudadano(),
                          onChange: ({ target: { value } }) => {
                            if (!value) {
                              resetAndValidate();
                            }
                          },
                        }}
                        resultProps={{
                          name: 'ciudadano',
                          label: 'ciudadano',
                          dataSource: ciudadanoFound,
                          labelProp: 'nombre_completo',
                          onClearConfirm: resetAndValidate,
                          contentConfirm: 'Si se realiza, se quitará cualquier relación con la empresa.',
                          breakPoints: {
                            xs: 24,
                            sm: 24,
                            md: 8,
                          },
                        }}
                      />
                      <Col xs={24} sm={24} md={24} />
                      <Title level={4}>Datos de contacto</Title>
                      <Divider orientation="left" orientationMargin="0" style={{ marginTop: 0 }} />
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="nombre_del_gerente_propietario"
                          label="Nombre de Gerente Propietario"
                          maxLength={250}
                          required
                          hasFeedback
                        >
                          <Input disabled={justView} allowClear />
                        </Form.Item>
                      </Col>
                      <Col md={16} />
                      <LadaNumero
                        form={form}
                        names={{ lada: 'lada_fijo', numero_de_telefono: 'telefono_fijo' }}
                        tooltip={(
                          <span>
                            Teléfono Fijo de la Empresa
                            <br />
                            <b>Ejemplo: 6536906857</b>
                          </span>
                        )}
                        label="Teléfono Fijo"
                        disabled={justView}
                      />
                      <LadaNumero
                        form={form}
                        disabled={justView}
                        names={{ lada: 'lada_celular', numero_de_telefono: 'telefono_celular' }}
                        tooltip={(
                          <span>
                            Teléfono Celular de la Empresa
                            <br />
                            <b>Ejemplo: 6536906857</b>
                          </span>
                        )}
                        label="Teléfono Celular"
                      />
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="sitio_de_internet"
                          rules={rules.sitio_web}
                          label="Sitio de Internet"
                          hasFeedback
                        >
                          <Input disabled={justView} allowClear />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="correo_electronico"
                          rules={rules.email}
                          label="Correo electrónico"
                          hasFeedback
                        >
                          <Input disabled={justView} allowClear />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="estados_globales"
                          label="Estado"
                          hasFeedback
                        >
                          <Select
                            disabled={!selectedRowKeys.length}
                            dataSource={estadosGlobales}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Form.Item hidden>
                      <Button htmlType="submit" />
                    </Form.Item>
                  </Form>
                </TabPane>
                <TabPane
                  tab="Domicilio"
                  key="domicilio"
                  disabled={!selectedRowKeys.length}
                  forceRender={selectedRowKeys?.length}
                >
                  <Direccion
                    mutable={mutable && !justView}
                    currentURI={baseURI}
                    parentID={selectedRowKeys[0]}
                    setLoading={setLoading}
                    onError={onError}
                    setFormAddress={setFormAddress}
                    setCurrentTabKey={setCurrentTabKey}
                    addressPropName="direccion_de_ubicacion"
                    allowVerify
                    callback={(values, _continue) => {
                      if (!_continue) {
                        onCancel();
                      } else {
                        const [key] = selectedRowKeys;
                        const clone = [...data?.results];
                        const mappedData = clone?.map((e) => (e.id === key
                          ? ({ ...e, direccion_de_ubicacion: values?.id }) : e));
                        setData(mappedData);
                      }
                    }}
                    permission={addressPermission}
                  />
                </TabPane>
                <TabPane tab="Clasificación Empresarial" key="info">
                  <Form
                    name="info"
                    layout="vertical"
                    form={formInfo}
                    onFinish={() => onFinish()}
                    scrollToFirstError
                  >
                    <Row gutter={10}>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipo_de_empresa"
                          label="Tipo de Empresa"
                          hasFeedback
                        >
                          <Select disabled={justView} dataSource={tiposDeEmpresa} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipo_de_establecimiento"
                          label="Tipo de Establecimiento"
                          hasFeedback
                        >
                          <Select
                            disabled={justView}
                            dataSource={tipoDeEstablecimiento}
                            labelProp="nombre"
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="clasificacion_de_comercio"
                          label="Clasificación de comercio"
                          hasFeedback
                        >
                          <Select
                            disabled={justView}
                            dataSource={clasificacionesDeComercio}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="fecha_de_apertura"
                          label="Fecha de apertura"
                          hasFeedback
                        >
                          <DatePicker
                            disabled={justView}
                            format={DATE_FRONTEND_FORMAT}
                            placeholder=""
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="fecha_de_cierre"
                          label="Fecha de cierre"
                          hasFeedback
                        >
                          <DatePicker
                            disabled={justView}
                            format={DATE_FRONTEND_FORMAT}
                            placeholder=""
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="fecha_de_alta_de_padron_empresa"
                          label="Fecha de alta de Padrón"
                          hasFeedback
                        >
                          <DatePicker
                            disabled={justView}
                            format="DD/MM/YYYY"
                            placeholder=""
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8} />
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="clase_actividad_empresarial_principal"
                          label="Clase de Actividad Local"
                          hasFeedback
                          tooltip="Clase de Actividad Local"
                        >
                          <Select
                            dataSource={claseActividad}
                            allowClear
                            disabled={justView}
                          />
                        </Form.Item>
                      </Col>
                      <InputSearchPro
                        label="Clase de actividad SCIAN"
                        tooltip="Búsqueda de actividades económicas"
                        name="q"
                        disabled={justView}
                        onClickAdvanced={() => setvisibleAdvanced(true)}
                        breakPoints={{
                          xs: 24,
                          sm: 24,
                          md: 8,
                        }}
                        inputProps={{
                          onPressEnter: () => onSearchSCIAN(),
                          onChange: ({ target: { value } }) => {
                            if (!value) {
                              resetAndValidateActividad();
                            }
                          },
                        }}
                        resultProps={{
                          dataSource: actividadFound,
                          name: 'giros_scian',
                          label: 'Clase de actividad SCIAN',
                          labelProp: 'titulo_completo',
                          onClear: resetAndValidateActividad,
                          breakPoints: {
                            xs: 24,
                            sm: 24,
                            md: 8,
                          },
                        }}
                      />
                      <Col span={24}>
                        <Form.Item
                          name="observaciones"
                          label="Observaciones"
                        >
                          <TextArea
                            allowClear
                            autoSize={{ minRows: 4, maxRows: 5 }}
                            maxLength={250}
                            disabled={justView}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Form.Item hidden>
                      <Button htmlType="submit" />
                    </Form.Item>
                  </Form>
                </TabPane>
                <TabPane tab="Datos complementarios" key="complementarios">
                  <Form
                    name="fiscales"
                    layout="vertical"
                    form={formFiscales}
                    onFinish={() => onFinish()}
                    scrollToFirstError
                  >
                    <Row gutter={10}>
                      {!predio.length ? (
                        <>
                          <Col xs={24} sm={24} md={24}>
                            <InputSearchPro
                              onChange={onSearch}
                              label="Clave Catastral"
                              name="q"
                              disabled={justView}
                              onClickAdvanced={() => setVisibleBusqueda(true)}
                              inputProps={{
                                onPressEnter: () => {
                                  clearTimeout(timeoutBusqueda);
                                  handleSearch();
                                },
                                onChange: ({ target: { value } }) => {
                                  if (!value) {
                                    resetAndValidateActividad();
                                  }
                                },
                              }}
                              resultProps={{
                                name: 'predio',
                                label: 'Clave Catastral',
                                dataSource: predio,
                                disabled: justView,
                                labelProp: 'participe_principal',
                                onClear: () => setPredio([]),
                                breakPoints: {
                                  xs: 24,
                                  sm: 24,
                                  md: 8,
                                },
                              }}
                              title="Búsqueda por Cuenta Única Predial"
                            />
                          </Col>
                          <Col xs={24} sm={24} md={0} />
                        </>
                      ) : (
                        <>
                          <Col xs={24} sm={24} md={8}>
                            <Form.Item
                              name="predio"
                              label="Clave Catastral"
                            >
                              <Select
                                disabled={justView}
                                dataSource={predio}
                                onChange={(val) => {
                                  if (!val) {
                                    setPredio([]);
                                    // formFiscales.resetFields(['q']);
                                  }
                                }}
                                render={(e) => `${e.id} - ${e?.participe_principal}`}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={16} />
                        </>
                      )}
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="superficie_del_terreno"
                          label="Sup. del Terreno (m2)"
                          allowClear
                          decimal
                          disabled={justView}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="superficie_construida_del_terreno"
                          label="Sup. Construida del Terreno (m2)"
                          allowClear
                          decimal
                          disabled={justView}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="zona_de_carga_descarga"
                          label="Carga y descarga (m2)"
                          allowClear
                          decimal
                          disabled={justView}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tiene_estacionamiento"
                          label="¿Tiene Estacionamiento?"
                        >
                          <Select
                            disabled={justView}
                            trueFalse
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="numero_de_cajones_de_estacionamiento"
                          label="No. De Cajones de Estacionamiento"
                          allowClear
                          disabled={justView}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="estacionamiento_descripcion"
                          label="Descripción de Estacionamiento"
                        >
                          <Input
                            disabled={justView}
                            allowClear
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="zona_de_carga_descarga"
                          label="Zona de Carga/Descarga"
                          tooltip="Metros cuadrados o lineales indicados como zona de carga y descarga."
                          allowClear
                          decimal
                          disabled={justView}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="numero_de_empleados"
                          label="No. de empleados"
                          allowClear
                          disabled={justView}
                        />
                      </Col>
                      {permission.tabs.anuncio.view && (
                        <>
                          <Col xs={24} sm={24} md={24} />
                          <Title level={4}>Anuncios comerciales</Title>
                          <Anuncios
                            selectedRowKey={selectedRowKeys[0]}
                            mutable={mutable || !justView}
                            permission={permission.tabs.anuncio}
                          />
                        </>
                      )}
                    </Row>
                  </Form>
                </TabPane>
              </Tabs>
            </Card>
          )}
          <BusquedaAvanzadaPredio
            tipoDePadron={1}
            visible={visibleBusquedaAvanzada}
            setVisible={setVisibleBusquedaAvanzada}
            callback={(_ciudadano) => fetchCiudadano(_ciudadano.id)}
          />
          <BusquedaAvanzadaPredio
            tipoDePadron={15}
            visible={visibleBusquedaContribuyente}
            setVisible={setVisibleBusquedaContribuyente}
            callback={(_contribuyente) => fetchContribuyente(_contribuyente?.id || _contribuyente)}
          />
          <BusquedaAvanzadaPredio
            tipoDePadron={3}
            visible={visibleBusqueda}
            setVisible={setVisibleBusqueda}
            // dataExterno={dataExterno}
            // setDataExterno={setDataExterno}
            callback={(selected) => { fetchPredio(selected.id); setPredio([selected]); }}
          />
          <BusquedaAvanzadaSCIAN
            visible={visibleAdvanced}
            setVisible={setvisibleAdvanced}
            callback={(_scian) => fetchClaseScian(_scian.id)}
            dataExterno={dataExterno}
            setDataExterno={setDataExterno}
          />
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => setVisibleAlert(false)}
            visible={visibleAlert}
            content={`la Empresa ${form.getFieldValue('nombre_comercial')}`}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default Empresas;
